import { render, staticRenderFns } from "./ChooseGoods.vue?vue&type=template&id=15d37ce9&scoped=true"
import script from "./ChooseGoods.vue?vue&type=script&lang=ts"
export * from "./ChooseGoods.vue?vue&type=script&lang=ts"
import style0 from "./ChooseGoods.vue?vue&type=style&index=0&id=15d37ce9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d37ce9",
  null
  
)

export default component.exports